/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Shapes } from '../shapes';
import { CircularMenu } from '../../reuseable';
import 'styles/control.scss';


export class Control extends Component {
  render() {
    const {
      addShape, styleObject, getConnectorSettings, connectorSettings,
    } = this.props;
    return (
      <div className="control">
        <CircularMenu
          items={Shapes}
          styleObject={styleObject}
          onShapeClick={(shapeName) => {
            addShape({ shapeName, text: '' });
          }}
          getConnectorSettings={getConnectorSettings}
          connectorSettings={connectorSettings}
        />
      </div>
    );
  }
}

Control.propTypes = {
  addShape: PropTypes.func.isRequired,
  styleObject: PropTypes.instanceOf(Object).isRequired,
  connectorSettings: PropTypes.instanceOf(Object).isRequired,
  getConnectorSettings: PropTypes.func.isRequired,
};
